/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferChapter} from "./offerChapter.zod";
import {OfferRichTextContent} from "./offerRichTextContent.zod";

export const OfferContent = zod
  .object({
    header: OfferRichTextContent,
    chapters: zod.array(OfferChapter),
    footer: OfferRichTextContent,
  })
  .describe(
    "Atomic authored content replacement. Chapter IDs unique across content; variables unique per scope. Empty text\/catalog content allowed. Customer successors retain all authored values and flags. Template instantiation alone clears unremembered inputs.",
  );

export type OfferContent = zod.input<typeof OfferContent>;
export type OfferContentOutput = zod.output<typeof OfferContent>;
